import Layout from '@/layout';

export default {
  weight: 7,
  path: '/swiper',
  component: Layout,
  redirect: '/swiperList',
  name: 'swiper',
  meta: { title: '宣传图管理', icon: 'el-icon-s-finance' },
  children: [
    {
      path: 'swiperList',
      name: 'swiperList',
      component: () => import('@/views/swiper/swiperList'),
      meta: { title: '首页宣传图', icon: 'el-icon-s-data' },
    },
    {
      path: 'swiperDetails',
      name: 'swiperDetails',
      component: () => import('@/views/swiper/swiperDetails'),
      meta: { title: '宣传图详情', icon: 'el-icon-s-data', activeMenu: '/swiper/swiperList' },
      hidden: true,
    },
    {
      path: 'mainDisplayList',
      name: 'mainDisplayList',
      component: () => import('@/views/swiper/mainDisplayList'),
      meta: { title: '主页模块', icon: 'el-icon-s-data' },
    },
    {
      path: 'mainDisplayDetails',
      name: 'mainDisplayDetails',
      component: () => import('@/views/swiper/mainDisplayDetails'),
      meta: { title: '主页模块详情', icon: 'el-icon-s-data', activeMenu: '/swiper/mainDisplayList' },
      hidden: true,
    },
  ],
};
